
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jetzt-registrieren",
      function () {
        return require("private-next-pages/jetzt-registrieren.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jetzt-registrieren"])
      });
    }
  